import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useLang } from "@/lib/i18n";

// Published CMS content: {"home.hero": {de:{...}, en:{...}}, ...}
const ContentContext = createContext({ content: {}, refresh: () => {} });

export function ContentProvider({ children }) {
  const [content, setContent] = useState({});

  const refresh = useCallback(() => {
    api
      .get("/public/content")
      .then((res) => setContent(res.data || {}))
      .catch(() => {
        /* keep hardcoded fallbacks */
      });
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return <ContentContext.Provider value={{ content, refresh }}>{children}</ContentContext.Provider>;
}

/** Returns the published fields of a CMS section for the active language. */
export function useContent(key) {
  const { content } = useContext(ContentContext);
  const { lang } = useLang();
  const section = content[key] || {};
  return section[lang] || section.de || {};
}

export const useContentRefresh = () => useContext(ContentContext).refresh;
